import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Zixun from './zixun';
import ZixunDetail from './zixun-detail';
import ZixunUpdate from './zixun-update';
import ZixunDeleteDialog from './zixun-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ZixunUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ZixunUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ZixunDetail} />
      <ErrorBoundaryRoute path={match.url} component={Zixun} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ZixunDeleteDialog} />
  </>
);

export default Routes;
